export default __webpack_public_path__ + "static/media/PlanarImg.91eb56c6.jpg";